// Converte cor hex para RGB
export function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

// Calcula a luminância relativa (baseado no padrão WCAG)
export function getLuminance(hex) {
  const rgb = hexToRgb(hex);
  if (!rgb) return 0;

  const { r, g, b } = rgb;
  const [rs, gs, bs] = [r / 255, g / 255, b / 255].map(val => {
    if (val <= 0.03928) {
      return val / 12.92;
    }
    return Math.pow((val + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

// Determina se uma cor é clara (true) ou escura (false)
export function isLightColor(hex) {
  const luminance = getLuminance(hex);
  return luminance > 0.5;
}

// Retorna a cor do texto apropriada (preto ou branco) baseado na cor de fundo
export function getContrastText(bgColor) {
  return isLightColor(bgColor) ? '#000000' : '#ffffff';
} 